import { render, staticRenderFns } from "./contract-new1.vue?vue&type=template&id=24c517c5&scoped=true"
import script from "./contract-new1.vue?vue&type=script&lang=js"
export * from "./contract-new1.vue?vue&type=script&lang=js"
import style0 from "./contract-new1.vue?vue&type=style&index=0&id=24c517c5&prod&lang=css"
import style1 from "./contract-new1.vue?vue&type=style&index=1&id=24c517c5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c517c5",
  null
  
)

export default component.exports